<script setup lang="ts">
import KpModal from '@kp/geofy-vuejs-lib/tg-system/components/KpModal.vue';
import { useI18n } from 'vue-i18n';

const props = withDefaults(
    defineProps<{
        title?: string;
        message?: string;
        confirmText?: string;
        cancelText?: string;
    }>(),
    {
        title: () => useI18n().t('confirm'),
        message: () => useI18n().t('confirm_rec_delete'),
        confirmText: () => useI18n().t('confirm'),
        cancelText: () => useI18n().t('cancel')
    }
);

const emit = defineEmits(['confirm', 'cancel']);
const show = defineModel({ default: false });
</script>

<template>
    <KpModal v-model="show">
        <h2 class="ktg-modal-title">{{ props.title }}</h2>
        <p class="ktg-modal-text">{{ props.message }}</p>
        <ktg-modal-buttons vertical>
            <ktg-button class="confirm-button" size="small" full-width @click="emit('confirm')">
                {{ props.confirmText }}
            </ktg-button>
            <ktg-button class="cancel-button" appearance="secondary" size="small" full-width @click="emit('cancel')">
                {{ props.cancelText }}
            </ktg-button>
        </ktg-modal-buttons>
    </KpModal>
</template>
